const SIZING_STYLE = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
];
function getSizingData(node) {
  const style = window.getComputedStyle(node);
  if (style === null) {
    return null;
  }
  const sizingStyle = pick(SIZING_STYLE, style);
  if (sizingStyle.boxSizing === "") {
    return null;
  }
  const paddingSize = parseFloat(sizingStyle.paddingBottom || "0") + parseFloat(sizingStyle.paddingTop || "0");
  const borderSize = parseFloat(sizingStyle.borderBottomWidth || "0") + parseFloat(sizingStyle.borderTopWidth || "0");
  return {
    sizingStyle,
    paddingSize,
    borderSize
  };
}
function pick(props, obj) {
  return props.reduce((acc, prop) => {
    acc[prop] = obj[prop];
    return acc;
  }, {});
}
export {
  getSizingData
};
//# sourceMappingURL=getSizingData.js.map
